import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Typography from "../../../../components/Typography";
import {email, required_message} from "../../../../utils/validations";
import {MuiTextField} from "../../../../components/MuiComponents/FormInputs";
import {useForm} from "react-hook-form";
import Button from "../../../../components/Button";
import {useMutation} from "react-query";
import {forgotPassword} from "../../../../api/mutations/auth";
import {useDispatch, useSelector} from "react-redux";
import {setForgotPasswordData, setFormError} from "../../../../redux/reducers/auth";
import MainLoader from "../../../../components/Loader/MainLoader";
import { AlertContext } from '../../../../components/SuccessOrFailedModal';

const EnterEmailModal = ({submit, close}) => {
    const { register, handleSubmit, formState: { errors, isValid },} = useForm({mode: 'onChange'})
    const dispatch = useDispatch()
    const mutation = useMutation(forgotPassword)
    const formErrors = useSelector(state => state.auth.formErrors)

    const [popup] = useContext(AlertContext)

    const onSubmit = async (data) => {
        try {
            await mutation.mutateAsync(data)
            dispatch(setForgotPasswordData({email: data.email}))
            submit("email")
        } catch (e) {
            dispatch(setFormError({
                forgot_password: e?.response?.data?.message || "error"
            }))
            ssoUserError()
        }
    }

    const ssoUserError = () => {
        popup({
            title: "Your Account is managed by your Organisation",
            variant: "warning!",
            description: "Please contact your administrator for assistance with access.",
            hideOkayButton: true
        })
        close();
    }

    let disabled = Object.keys(errors).length > 0 || !isValid || formErrors?.forgot_password?.length > 0
    return (
        <div>
            {mutation.isLoading && <MainLoader/>}
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
                <Typography variant={"h4"} className={"text-primary-800 pb-2.5"}>Hello There,</Typography>
                <Typography variant={"body1"}>Before setting a new password, please input the email id to receive the
                Verification Code.</Typography>
                <MuiTextField label={"Enter your email id"}
                              InputProps={{...register("email", {required: required_message, ...email})}}
                              error={Boolean(errors?.email)}
                              helperText={errors?.email?.message}
                              onKeyUp={() => {
                                  dispatch(setFormError({
                                      forgot_password: null
                                  }))
                              }}
                              type={"email"}
                />
                <Typography className={"text-functional-red"}>{formErrors?.forgot_password}</Typography>
                <Button disabled={disabled} className={"mt-2"}>Confirm</Button>
            </form>
        </div>
    );
};

EnterEmailModal.propTypes = {
    submit: PropTypes.func.isRequired
};

export default EnterEmailModal;
